<template>
  <div class="wrap">
      <div class="img">
          <img :src='require(`../assets/${img}`)' alt="">
      </div>
      <h1>{{header}}</h1>

      <p>{{text}}</p>
  </div>
</template>

<script>
export default {
 name: 'Card',
 props: ["header", "text", "img"]
}
</script>

<style lang="scss" scoped>
.wrap{
    border: 2px solid #b3b3b3;
    padding:20px;
    border-radius: 10px;
    text-align: center;
    h1{
        font-size: 22px;
        margin:20px 0px;
    }
    p{
        font-size: 1em;
        margin:20px auto;
        width:80%;
        color: #4d4d4d;
        line-height: 25px;
    }
}
@media (max-width:400px){
    .wrap{
        p{
            width: 100%;
        }
    }
}
</style>